// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#profile-page-inner-contents {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 20px;
    height: 100%;
}

/* Show manage entity popup when enabled on profile page */
#profile-page #popup-background {
    visibility: visible !important;
}

.profile-panel {
    background-color: #ffffff;
    height: 100%;
    border-radius: 25px;
    padding: 25px;
}

#about-user {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 20vw;
}

#about-user h1 {
    font-size: max(2vw, 25px);
    text-align: center;
    margin-bottom: 0;
    padding-bottom: 0;
}

#user-email {
    margin: 0;
    padding: 0;
}

/* Edit user button */
#about-user button {
    background-color: var(--light-purple);
    font-weight: bold;
    border-style: none;
    color: white;
    padding: 5px 10px 5px 10px;
}

/* Hovering over Edit user button */
#about-user button:hover {
    background-color: var(--dark-purple);
}

#about-user h2 {
    font-size: max(1.5vw, 20px);
    text-align: center;
    margin-top: 25px;
}

#classes {
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
}

.class {
    text-align: center;
    background-color: var(--dark-purple);
    color: white;
    border-radius: 10px;
    padding: 5px;
}

#user-images {
    flex-grow: 1;
}

#user-images .gallery {
    overflow: visible;
    flex-wrap: wrap;
}

@media screen and (max-width: 800px) {
    #profile-page-content {
        flex-wrap: wrap;
    }

    #about-user {
        width: 100%;
        padding: 0;
        background-color: transparent;
        margin-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/ProfilePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,YAAY;AAChB;;AAEA,0DAA0D;AAC1D;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,qCAAqC;IACrC,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,mCAAmC;AACnC;IACI,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,6BAA6B;QAC7B,gBAAgB;IACpB;AACJ","sourcesContent":["#profile-page-inner-contents {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    padding: 20px;\n    height: 100%;\n}\n\n/* Show manage entity popup when enabled on profile page */\n#profile-page #popup-background {\n    visibility: visible !important;\n}\n\n.profile-panel {\n    background-color: #ffffff;\n    height: 100%;\n    border-radius: 25px;\n    padding: 25px;\n}\n\n#about-user {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    width: 20vw;\n}\n\n#about-user h1 {\n    font-size: max(2vw, 25px);\n    text-align: center;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n#user-email {\n    margin: 0;\n    padding: 0;\n}\n\n/* Edit user button */\n#about-user button {\n    background-color: var(--light-purple);\n    font-weight: bold;\n    border-style: none;\n    color: white;\n    padding: 5px 10px 5px 10px;\n}\n\n/* Hovering over Edit user button */\n#about-user button:hover {\n    background-color: var(--dark-purple);\n}\n\n#about-user h2 {\n    font-size: max(1.5vw, 20px);\n    text-align: center;\n    margin-top: 25px;\n}\n\n#classes {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.class {\n    text-align: center;\n    background-color: var(--dark-purple);\n    color: white;\n    border-radius: 10px;\n    padding: 5px;\n}\n\n#user-images {\n    flex-grow: 1;\n}\n\n#user-images .gallery {\n    overflow: visible;\n    flex-wrap: wrap;\n}\n\n@media screen and (max-width: 800px) {\n    #profile-page-content {\n        flex-wrap: wrap;\n    }\n\n    #about-user {\n        width: 100%;\n        padding: 0;\n        background-color: transparent;\n        margin-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
